export const STEP = 'STEP';
export const SET_DRIVER_DATA = 'SET_DRIVER_DATA';